import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "@heroicons/react/24/solid";


function CinqQuestionsVendeur() {
  return (
    <section class=" flex flex-row flex-wrap justify-center items-center bg-slate-100">
                <div className="py-14 sm:py-20 ">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="mx-auto text-center">
                            <h2 className="text-3xl font-bold tracking-tight leading-10 text-gray-900 sm:text-4xl">
                                <span className="font-bold text-indigo-800">Vente immobilière chez le notaire</span>
                                : 4 informations importantes</h2>

                        </div>
                        <div className="mt-10 lg:col-span-7 lg:mt-0 sm:max-w-[60%] mx-auto">
                            <dl className="space-y-10">
                                <div className="bg-white my-4 rounded-lg p-4">
                                    <dt className="text-lg font-semibold leading-7 ">
                                        Quels sont les délais d'une vente immobiliere chez le notaire ?
                                    </dt>
                                    <dd className="mt-2 text-md leading-7 text-gray-600">
                                    Les délais pour finaliser une vente immobiliere chez le notaire sont généralement de 3 mois :

                                    <ul>

                                    <li>1. <b>Signature du compromis ou de la promesse de vente</b> : 1 à 2 semaines après accord.</li>

                                    <li>2. <b>Délai de rétractation </b>: 10 jours pour l’acheteur.</li>

                                    <li>3. <b>Obtention du financement</b> : 30 à 60 jours pour valider le prêt.</li>

                                    <li>4. <b>Signature de l’acte authentique chez le notaire</b> : Environ 3 mois après le compromis.</li>
                                    </ul>
                                    Ces délais peuvent varier selon la complexité de la transaction ou la disponibilité des parties impliquées.
                                    <br/>
                                    <br/>
                                    Plusieurs avantages avec Clotere :
                                    <ul>
                                        <li>
                                            <strong>On centralise tous les échanges pour y voir plus clair</strong>
                                        </li>
                                        <li>
                                            <strong>On contrôle les documents dès qu'ils sont ajoutés pour éviter les erreurs</strong>
                                        </li>
                                        <li>
                                            <strong>On permet de fixer les rendez-vous entre toutes les parties en 3 clics</strong>
                                        </li>
                                        </ul>
                                        Ca vous permet de gagner un temps fou, en moyenne 15 jours sur la vente de votre bien.
                                    </dd>
                                </div>

                                <div className="bg-white my-4 rounded-lg p-4">
                                    <dt className="text-lg font-semibold leading-7 ">
                                        Qui paye les frais de notaire ?
                                    </dt>
                                    <dd className="mt-2 text-md leading-7 text-gray-600">
                                    C'est généralement l'acheteur qui paye les frais de notaire.
                                    <br/>
                                    En tant que vendeur vous n'aurez pas à les payer, sauf si un accord à été passé entre vous.

                                    </dd>
                                </div>

                                <div className="bg-white my-4 rounded-lg p-4">
                                    <dt className="text-lg font-semibold leading-7 ">
                                        Quels sont les frais à prévoir pour la vente d'un bien immobilier ? 
                                    </dt>
                                    <dd className="mt-2 text-md leading-7 text-gray-600">
                                        Les frais de notaire sont à la charge de l'acheteur, pour autant des frais vendeur existent !
                                    La vente d'un bien immobilier ne se limite pas à la simple transaction entre le vendeur et l'acheteur. 
                                    Elle implique des frais annexes qu'il est important d'anticiper. 
                                    <br/>Comme par exemple : 
                                        <ul>
                                            <li className="font-bold"> • Les frais d'agence.</li>
                                            <li className="font-bold">• Les diagnostics immobilier</li>
                                            <li className="font-bold">. Les frais de copropriété.</li>
                                        </ul>
                                        Pour en savoir plus :  <Link to="/immobilier/notaire/frais-vente-notaire" className="block font-bold text-indigo-800"> 👋 La liste détaillée des frais liés à votre vente immobiliere</Link> 
                                        
                                    </dd>
                                </div>

                                <div className="bg-white my-4 rounded-lg p-4">
                                    <dt className="text-lg font-semibold leading-7 ">
                                        Quels documents fournir au notaire pour la vente d'un bien immobilier ?
                                    </dt>
                                    <dd className="mt-2 text-md leading-7 text-gray-600">
                                        Il y en a beaucoup ! 
                                        <br/>Voici une courte présentation de ce que vous devrez fournir au notaire :
                                        <ul>
                                            <li className="font-bold"> • Vos documents d'identité</li>
                                            <li className="font-bold">• Titre de propriété </li>
                                            <li className="font-bold">. Justificatifs de charges et taxes</li>
                                            <li className="font-bold">. Dossier de diagnostics techniques (DDT)</li>
                                            <li className="font-bold">• Documents relatifs à la copropriété (le cas échéant)</li>
                                        </ul>
                                        Pour ne pas vous y perdre, vous retrouverez dans votre espace client Clotere, la liste détaillée de tous les documents à fournir au notaire pour votre vente. C'est plus simple à suivre !
                                        <br/><br/>
                                        Pour en savoir plus : <Link to="/immobilier/notaire/documents-vente-notaire" className="block font-bold text-indigo-800">👋 Quels documents founir au notaire pour une vente immobiliere ?</Link> 
                                        
                                    </dd>
                                </div>

                            </dl>
                        </div>


                    </div>
                    <div className="mx-auto text-center container">
                        <p className="text-lg"> Débutez aujourd'hui votre dossier chez le notaire</p>
                        <Link to="/onboard/vente"
                            type="button"
                            className="btn-indigo p-6  no-underline inline-flex items-center gap-x-2 rounded-md bg-indigo-600 text-sm font-semibold text-white shadow-sm w-auto"
                        >
                            Débuter mon dossier
                            <ArrowRightIcon aria-hidden="true" className="-mr-0.5 size-5" />
                        </Link>
                    </div>

                </div>

            </section>
  );
}

export default CinqQuestionsVendeur;